module.exports = __webpack_public_path__ + "img/img (18).01b01142.jpg";